document.addEventListener(
  'DOMContentLoaded',
  function () {
    const showAlert = sessionStorage.getItem('mv-alert-hidden') !== 'true';
    if (!showAlert) {
      // Alert were closed before
      hideAlertsOnPage();
      return;
    }
    document.querySelectorAll('.alert-wrap button.alert-close-btn').forEach((e) => {
      e.addEventListener('click', closeAlert);
    });
  },
  false
);

function closeAlert(event) {
  sessionStorage.setItem('mv-alert-hidden', 'true');
  hideAlertsOnPage();
}

function hideAlertsOnPage() {
  document.querySelectorAll('.alert-wrap').forEach((e) => e.classList.add('d-none'));
}
